export default function ConversationStarters() {
    return {
        title: 'What is a Policy Review?',
        content:'It’s important to review insurance policies to ensure they align with your client’s needs and objectives. Carriers do not notify clients when their policy is off course. Often, policyholders are unaware that even though premiums are paid, due to interest rate decreases or increases in internal charges, the policy may be at risk of lapsing. These unfortunate events can be avoided by performing a simple policy review. After a proper review, your client will have a clear understanding of all aspects of their existing policy.'
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/policy-review/PolicyReviewInfo.js